import React from "react";

import "./AuthCanvas.scss";
import WhiteBox from "../../core/layouts/WhiteBox";
import { RouteKeys } from "../routes/route-keys";
import { Link } from "react-router-dom";
import logoimg from "../../assets/images/cityinfoLogotrans.png"
interface AuthCanvasProps {
  head: string;
}

const AuthCanvas: React.SFC<AuthCanvasProps> = (props) => {
  const { head } = props;
  return (
    <div className="form login">
      <div className="form__inner login__inner">
       

        <WhiteBox>
        <div className="d-block text-center">
          <div className="logo mb-4">
            <Link to={RouteKeys.Home}>
              <img src={logoimg} style={{width : "140px"}}/>
            </Link>
          </div>
        </div>
          <h6 className="mb-3">{head}</h6>
          {props.children}
        </WhiteBox>
      </div>
    </div>
  );
};

export default AuthCanvas;
